import * as React from "react";
import { DataGridPremium, GridColDef } from "@mui/x-data-grid-premium";
import CclDataGridToolbar from "../../components/common/cclDataGridToolbar/cclDataGridToolbar";
import { useGetGroupInventoryQuery } from "../../services/cclTokenedAssessmentApi";

interface AssessmentsInventoryDataGridProps {
    groupKey: number;
}

const COLUMNS: GridColDef[] = [
    {
        field: "instrumentName",
        headerName: "Assessment",
        headerAlign: "left",
        align: "left",
        flex: 2,
    },
    {
        field: "availableQty",
        headerName: "Unused",
        type: "number",
        headerAlign: "left",
        align: "left",
        flex: 1,
    },
    {
        field: "reservedQty",
        headerName: "Pending",
        type: "number",
        headerAlign: "left",
        align: "left",
        flex: 1,
    },
    {
        field: "projectedAvailable",
        headerName: "Available",
        type: "number",
        headerAlign: "left",
        align: "left",
        flex: 1,
    },
];

const AssessmentsInventoryDataGrid: React.FC<AssessmentsInventoryDataGridProps> = (props) => {
    const { data, isLoading } = useGetGroupInventoryQuery(props.groupKey, {
        skip: !props.groupKey || !Number.isFinite(props.groupKey),
    });
    const rows = React.useMemo(
        () =>
            (data ?? []).map((row) => ({
                ...row,
                id: `${row.aagKey}_${row.formMasterKey}_${row.partNumber}`,
            })),
        [data],
    );

    return (
        <DataGridPremium
            rows={rows}
            columns={COLUMNS}
            loading={isLoading}
            autoHeight
            disableSelectionOnClick
            components={{ Toolbar: CclDataGridToolbar }}
            componentsProps={{
                toolbar: {
                    showSaveState: false,
                    hideSettingsButtons: true,
                },
            }}
        />
    );
};

export default AssessmentsInventoryDataGrid;
